import React from 'react'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons'
import { colors } from '../style/constants'

export function SpinnerThird({
  color = colors.primary400,
  ...props
}: Omit<FontAwesomeIconProps, 'icon' | 'color'> & { color?: string | null }) {
  return <FontAwesomeIcon icon={faSpinnerThird} spin color={color ?? undefined} {...props} />
}
